
import { supabase } from '@/integrations/supabase/client';

export type SubmissionData = {
  contact: {
    name: string;
    company: string;
    position: string;
    email: string;
    website: string;
    phone: string; // Added phone field
  };
  calculatorData: {
    listSize: number;
    industry: string;
    frequency: number;
    result: any;
  };
};

/**
 * Submits calculator data to Supabase database and triggers admin notification
 */
export const submitCalculatorData = async (data: SubmissionData) => {
  try {
    // Get gross revenue values instead of profit values
    const minRevenue = data.calculatorData.result.minEarnings || 0;
    const maxRevenue = data.calculatorData.result.maxEarnings || 0;
    
    // Format the weekly revenue as text
    const weeklyRevenueText = `$${Math.round(minRevenue)} - $${Math.round(maxRevenue)}`;
    
    // Prepare the submission data
    const submissionData = {
      name: data.contact.name,
      email: data.contact.email,
      company: data.contact.company,
      position: data.contact.position,
      website: data.contact.website,
      phone_number: data.contact.phone, // Added phone field
      list_size: data.calculatorData.listSize,
      industry: data.calculatorData.industry,
      frequency: data.calculatorData.frequency,
      weekly_profit: weeklyRevenueText, // Still using 'weekly_profit' field name to maintain DB compatibility
      calculation_result: data.calculatorData.result // Save the full calculation result
    };

    // Insert data into the newsletter_submissions table
    const { error } = await supabase
      .from('newsletter_submissions')
      .insert(submissionData);

    if (error) {
      console.error('Error inserting data:', error);
      throw new Error('Failed to save your submission');
    }

    // Send admin notification
    try {
      const notificationResponse = await supabase.functions.invoke('send-admin-notification', {
        body: submissionData
      });
      
      console.log('Admin notification response:', notificationResponse);
      
      if (notificationResponse.error) {
        console.error('Error sending admin notification:', notificationResponse.error);
        // We don't throw an error here to not block the user's experience
        // The submission was still saved to the database
      }
    } catch (notificationError) {
      console.error('Failed to send admin notification:', notificationError);
      // We continue despite notification errors
    }

    return { success: true };
  } catch (err) {
    console.error('API error:', err);
    throw err;
  }
};
